import React from 'react';
import { Box } from '@mui/material';

interface Props {
  value: Date;
  children?: React.ReactNode;
}

const TimeSlotWrapper = React.forwardRef<HTMLDivElement, Props>(
  ({ value, children }, ref) => {
    const [isCurrentTimeSlot, setIsCurrentTimeSlot] = React.useState(() => {
      const now = new Date();
      const slotStart = new Date(value);
      const slotEnd = new Date(slotStart.getTime() + 30 * 60000);
      return now >= slotStart && now < slotEnd;
    });

    React.useEffect(() => {
      const checkCurrentTimeSlot = () => {
        const now = new Date();
        const slotStart = new Date(value);
        const slotEnd = new Date(slotStart.getTime() + 30 * 60000);
        setIsCurrentTimeSlot(now >= slotStart && now < slotEnd);
      };

      const timer = setInterval(checkCurrentTimeSlot, 60000);
      return () => clearInterval(timer);
    }, [value]);

    return (
      <Box
        ref={ref}
        sx={{
          height: '100%',
          bgcolor: isCurrentTimeSlot ? 'primary.lighter' : 'transparent',
          transition: 'background-color 0.2s ease',
          borderBottom: '1px solid',
          borderColor: 'divider',
          '&:last-child': {
            borderBottom: 'none'
          }
        }}
        role="presentation"
        aria-current={isCurrentTimeSlot ? 'time' : undefined}
      >
        {children}
      </Box>
    );
  }
);

const TimeSlot = () => {
  return (
    <div>
      Some ex
    </div>
  );
}

TimeSlotWrapper.displayName = 'TimeSlotWrapper';

export { TimeSlotWrapper, TimeSlot };